<template>
    <div class="page-header pt-4 pb-4">
        <h3>{{ title }}</h3>
    </div>
</template>

<script>
export default {
    name: 'page-header',
    props: ['menus'],
    data () {
        return {
            title: ''
        }
    },
    mounted () {
        this.setTitle()
    },
    watch: {
        menus: {
            handler: function (val) {
                this.setTitle()
            },
            deep: true
        },
        '$route.path': {
            handler: function () {
                this.setTitle()
            },
            deep: true
        }
    },
    methods: {
        setTitle () {
            const currentRouteName = this.$route.name
            const breadcrumbName = this.$route.meta.breadcrumbName

            this.title = this.menus.some(item => item.name === currentRouteName)
                ? this.menus.find(item => item.name === currentRouteName).title
                : breadcrumbName
        }
    }
}
</script>

<style lang="stylus" scoped>
    .page-header
        h3
            font-size: 24px
            display: inline
            font-weight: 300
            letter-spacing: normal
</style>
